(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.bg = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Няма открити данни'
      },
      combobox: {
        placeholder: 'Избор',
        searchPlaceholder: 'Търсене'
      },
      datepicker: {
        apply: 'Прилагане',
        clearSelection: 'Изчистване',
        pickADays: 'Избор на дни',
        prevYear: 'Предишна година',
        nextYear: 'Следваща година',
        prevMonth: 'Предишен месец',
        nextMonth: 'Следващ месец',
        year: '',
        month1: 'Януари',
        month2: 'Февруари',
        month3: 'Март',
        month4: 'Април',
        month5: 'Май',
        month6: 'Юни',
        month7: 'Юли',
        month8: 'Август',
        month9: 'Септември',
        month10: 'Октомври',
        month11: 'Ноември',
        month12: 'Декември',
        weeks: {
          sun: 'Нед',
          mon: 'Пон',
          tue: 'Вто',
          wed: 'Сря',
          thu: 'Чет',
          fri: 'Пет',
          sat: 'Съб'
        },
        months: {
          jan: 'Янр',
          feb: 'Фев',
          mar: 'Мар',
          apr: 'Апр',
          may: 'Май',
          jun: 'Юни',
          jul: 'Юли',
          aug: 'Авг',
          sep: 'Сеп',
          oct: 'Окт',
          nov: 'Ное',
          dec: 'Дек'
        },
        pickADay: 'Избор на ден'
      },
      timepicker: {
        meridiemAM: 'Преди обяд (AM)',
        meridiemPM: 'След обяд (PM)'
      },
      dropdown: {
        noDataMessage: 'Няма открити данни'
      },
      filepicker: {
        browse: 'Разглеждане',
        select: 'Избор на файл'
      },
      filter: {
        apply: 'Прилагане',
        cancel: 'Отказ',
        filterButton: 'Филтър',
        reset: 'Нулиране на филтри',
        resetDefault: 'Възстановяване до настройки по подразбиране'
      },
      search: {
        noDataMessage: 'Няма открити данни'
      },
      'multi-search': {
        'separator-and': 'И',
        'search-button': 'Търсене',
        'search-placeholder': 'Търсене по име'
      },
      select: {
        all: 'Всички',
        clearSelection: 'Изчистване на избора',
        noMatch: 'Няма открити данни',
        noData: 'Няма данни',
        placeholder: 'Избор',
        item: 'елемент(а)',
        selected: 'избрано',
        found: 'намерен'
      },
      upload: {
        browseButton: 'Разглеждане',
        text: 'Плъзгайте и пускайте файлове за качване или щракнете върху „Разглеждане“',
        tip: 'Можете да качите 10 файла, като всеки трябва да е до 25 MB'
      },
      table: {
        emptyText: 'Няма данни'
      },
      tree: {
        emptyText: 'Няма данни'
      }
    }
  };
  _exports.default = _default;
});